export default "__VITE_ASSET__Dy3E9lnC__"